import { takeLatest, call, put } from 'redux-saga/effects';
import {
  LOAD_MOKA_CONFIG_LIST,
  LOAD_MOKA_CONFIG_LOGS_LIST,
  SUBMIT_MOKA_CONFIG_EDIT_FORM,
} from 'state/actionTypes';
import * as api from 'api/mokaConfig/config';
import * as toast from 'state/toast/actions';
import { setMokaConfigList, setMokaConfigLogs } from 'state/mokaConfig/actions';

export function* loadMokaConfigList() {
  try {
    const response = yield call(api.getMokaConfig);
    yield put(
      setMokaConfigList(
        response.data.data.subscription_prices,
        response.data.data.subscription_discounts
      )
    );
  } catch (error) {
    yield put(
      toast.errorMessage('Load Moka Config list failed', error.message)
    );
  }
}

export function* updateMokaConfig({ payload }) {
  const { prices, discounts, moka } = payload;
  const subPrices = prices.concat(moka);
  try {
    const response = yield call(api.updateMokaConfig, {
      subscription_prices: subPrices,
      subscription_discounts: discounts,
    });
    yield put(
      setMokaConfigList(
        response.data.data.subscription_prices,
        response.data.data.subscription_discounts
      )
    );
    yield put(toast.successMessage(`Successfully update Moka Config!`));
  } catch (error) {
    yield put(toast.errorMessage('Update Moka Config failed', error.message));
  }
}

export function* loadMokaConfigLogs({ paging }) {
  try {
    const response = yield call(api.getMokaConfigLogs, paging);
    yield put(setMokaConfigLogs(response.data.data, response.data.paging));
  } catch (error) {
    yield put(
      toast.errorMessage('Load Moka Config Logs failed', error.message)
    );
  }
}

export default function*() {
  yield takeLatest(LOAD_MOKA_CONFIG_LIST, loadMokaConfigList);
  yield takeLatest(SUBMIT_MOKA_CONFIG_EDIT_FORM, updateMokaConfig);
  yield takeLatest(LOAD_MOKA_CONFIG_LOGS_LIST, loadMokaConfigLogs);
}
